import { useCallback, useSyncExternalStore } from 'react';
import { readSession, subscribeToSession, type AdminSession, type AdminRole } from './session';

/**
 * The live session. Re-renders on sign-in and sign-out.
 *
 * Reads through `readSession`, which has no side effects — a snapshot getter
 * that cleared expired state would notify subscribers during a render.
 */
export function useSession(): AdminSession | null {
  return useSyncExternalStore(subscribeToSession, readSession, () => null);
}

export function useRole(): AdminRole | undefined {
  return useSession()?.role;
}

/**
 * ⚠️ Presentation only. Every one of these answers is re-decided by the server,
 * which returns `403 INSUFFICIENT_ROLE` regardless of what this returned. Use it
 * to avoid drawing a dead control, never to protect anything.
 */
export function useHasRole(): (roles: readonly AdminRole[]) => boolean {
  const role = useRole();
  return useCallback((roles: readonly AdminRole[]) => !!role && roles.includes(role), [role]);
}
